export default __webpack_public_path__ + "static/media/terms.03e2a13c.md";